import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Main from "./Main";
import Blog from "./pages/Blog";
import Home from "./Home";
import Footer from './components/Footer';
// import Forms from "./pages/Forms";
import Invoice from "./pages/Invoice";
import LandingPage from "./pages/LandingPage";
import Navbar from "./components/Navbar";
import Invite from "./pages/Invite";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/forms" element={<Forms />} />*/}
          <Route path="/invoices" element={<Invoice />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/landingPages" element={<LandingPage />} />
          <Route path="/coupons" element={<Main />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
      </Router>

      <Footer />
    </div>
  );
}

export default App;